import React, { useState } from 'react';
import { Star, ShieldCheck, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function TestimonialsAndFaq() {
  const faqs = [{
    q: '¿Cómo recibo Aula de Éxitos después de comprar?',
    a: 'Inmediatamente después del pago recibís el link de descarga en tu correo. En menos de 5 minutos tenés todo listo en tu dispositivo.'
  }, {
    q: '¿Sirve para cualquier escuela de Uruguay?',
    a: 'Sí. Está alineado al EBI de ANEP que es el mismo en todo el país. Funciona igual en Artigas que en Montevideo.'
  }, {
    q: '¿Es editable?',
    a: 'Es 100% PDF listo para usar e imprimir. Podés anotarlo con Adobe Acrobat o herramientas similares.'
  }, {
    q: '¿Los bonos están en todas las opciones?',
    a: 'Sí. Los 6 bonos estratégicos están incluidos en todas las opciones. Sin costo extra. Siempre.'
  }, {
    q: '¿Puedo comprar un tramo ahora y otro después?',
    a: 'Sí. Pero si sabés que vas a necesitar más de uno el Megapack te ahorra $1.070.'
  }, {
    q: '¿Sirve si soy maestro con poca experiencia?',
    a: 'Especialmente para vos. Todo está listo solo lo usás. Sin necesidad de experiencia previa.'
  }, {
    q: '¿Sirve para grupos difíciles?',
    a: 'Sí. Cada tramo incluye actividades específicas para cuando el grupo no puede ese día.'
  }, {
    q: '¿Está actualizado al EBI 2026?',
    a: 'Sí. Diseñado específicamente para el EBI de ANEP Uruguay 2026. Uruguayo de origen no es un material adaptado.'
  }, {
    q: '¿Tiene garantía real?',
    a: '7 días de garantía total. Si no es lo que esperabas · te devolvemos el 100%. Sin preguntas.'
  }, {
    q: '¿Qué lo diferencia de otros materiales?',
    a: 'Tres cosas: es uruguayo · es un sistema completo y resuelve todo el año — 36 semanas · 8 áreas · de marzo a diciembre.'
  }];
  return <>
      {/* SECCIÓN 8: TESTIMONIOS */}
      <section className="py-16 px-4 bg-brand-lightBlue" data-id="element-152">
        <div className="max-w-5xl mx-auto" data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-deep text-center mb-12" data-id="element-154">
            Esto dicen sobre Aula de Éxitos:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-155">
            {[{
            quote: 'Compré el Megapack un domingo. El lunes tenía todo el año organizado. Las rúbricas EBI son un lujo — evalúo en minutos y sin dudas.',
            author: 'Ana G.',
            loc: 'Montevideo · 5° y 6° año',
            initials: 'AG'
          }, {
            quote: 'Empecé con el Tramo 1. A los 3 días compré el Megapack completo. Trabajo en una escuela rural con múltiples grados y por fin tengo todo alineado al EBI.',
            author: 'Marcela F.',
            loc: 'Rivera · Inicial y 1°',
            initials: 'MF'
          }, {
            quote: 'Está organizado por tramo y alineado al EBI de ANEP. Es como tener un colega experto que ya hizo todo el trabajo por mí.',
            author: 'Roberto B.',
            loc: 'Salto · 3° y 4° año',
            initials: 'RB'
          }, {
            quote: 'Mis alumnos de 5° por fin se enganchan con todas las áreas. El contenido los conecta con Uruguay real. Ya no peleo con el teléfono en clase.',
            author: 'Carolina P.',
            loc: 'Canelones · 5° año',
            initials: 'CP'
          }].map((test, i) => <div key={i} className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm" data-id="element-156">
                <div className="flex text-yellow-400 mb-4" data-id="element-157">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-158" />)}
                </div>
                <p className="text-brand-text font-medium mb-6 text-lg" data-id="element-159">
                  "{test.quote}"
                </p>
                <div className="flex items-center gap-4" data-id="element-160">
                  <div className="w-12 h-12 bg-brand-blue text-white rounded-full flex items-center justify-center font-bold text-lg" data-id="element-161">
                    {test.initials}
                  </div>
                  <div data-id="element-162">
                    <div className="font-bold text-brand-deep" data-id="element-163">
                      {test.author}
                    </div>
                    <div className="text-sm text-brand-gray" data-id="element-164">{test.loc}</div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECCIÓN 9: GARANTÍA */}
      <section className="py-16 px-4 bg-brand-greenSoft text-center" data-id="element-165">
        <div className="max-w-2xl mx-auto" data-id="element-166">
          <ShieldCheck className="w-20 h-20 text-brand-green mx-auto mb-6" data-id="element-167" />
          <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-deep mb-6" data-id="element-168">
            GARANTÍA 7 DÍAS
          </h2>
          <p className="text-xl text-brand-text font-medium mb-4" data-id="element-169">
            Usalo en el aula. Si en 7 días no es lo que esperabas · devolución
            100%. Sin preguntas. Sin formularios.
          </p>
          <p className="font-bold text-brand-green" data-id="element-170">
            +500 docentes ya confiaron.
          </p>
        </div>
      </section>

      {/* SECCIÓN 10: FAQ */}
      <section className="py-16 px-4 bg-white" data-id="element-171">
        <div className="max-w-3xl mx-auto" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-deep text-center mb-10" data-id="element-173">
            ❓ Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-174">
            {faqs.map((faq, i) => <FaqItem key={i} question={faq.q} answer={faq.a} data-id="element-175" />)}
          </div>
        </div>
      </section>
    </>;
}
function FaqItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-xl overflow-hidden bg-white" data-id="element-176">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 text-left hover:bg-brand-lightBlue/40 flex justify-between items-center gap-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue" data-id="element-177">
        <span className="font-bold text-brand-deep text-lg" data-id="element-178">{question}</span>
        <ChevronDown className={`w-5 h-5 text-brand-gray transition-transform flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-179" />
      </button>
      <AnimatePresence data-id="element-180">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} data-id="element-181">
            <div className="px-6 pb-4 pt-2 text-brand-text font-medium" data-id="element-182">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}